import ReactPlayer from 'react-player'

import { styled } from '@mui/material'

import { Body2, Stack } from '@collaborate-health/uikit'

export const Container = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2),
  maxWidth: 400,
  maxHeight: 500,
  overflowX: 'hidden',
  overflowY: 'auto',
}))

export const Description = styled(Body2)({
  wordBreak: 'break-word',
})

export const FormControlInfoImage = styled('img')(({ theme }) => ({
  maxWidth: '100%',
  maxHeight: 300,
  height: 'auto',
  borderRadius: theme.shape.borderRadius / 2,
  objectFit: 'contain',
  alignSelf: 'center',
}))

export const FormControlInfoVideo = styled(ReactPlayer)(({ theme }) => ({
  display: 'flex',
  maxWidth: '100%',
  maxHeight: 300,
  alignSelf: 'center',
  borderRadius: theme.shape.borderRadius / 2,
  overflow: 'hidden',
}))

